import { useState, useEffect, useRef, useCallback } from "react";
import CommentModal from "../../Models/CommentBoxModel/CommentBox";
import EmojiPicker from "emoji-picker-react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {
  TimelineInsert,
  TimelineGet,
  TimelineLike,
  DeletePost,
} from "../../apis/api/TimelineApi";
import { useDispatch, useSelector } from "react-redux";
import LazyLoad from "react-lazy-load";
import Lodderr from "../../components/Lodder/Lodder";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import "./Timeline.css";

const AllTimeline = () => {
  const dispatch = useDispatch();
  const [commentPost, setcommentPost] = useState();
  const [postToDelete, setPostToDelete] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [text, setText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const photoInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const musicInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [page, setPage] = useState(0);
  const [last_Id, setlast_Id] = useState(0);
  const [Loading, setLoading] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const throttleRef = useRef(null);
  const fetchingRef = useRef(false);
  const [posts, setPosts] = useState([]);

  const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const access = JSON.parse(Cookies.get("access"));
  const user = JSON.parse(Cookies.get("user"));


  const { loading } = useSelector((state) => state.TimelineSlice);

  const fetchPosts = useCallback(async () => {
    if (Loading || allLoaded || fetchingRef.current) return;

    fetchingRef.current = true;
    setLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));

      const response = await dispatch(
        TimelineGet({ userId, company_id, page, last_Id })
      );

      if (response.payload.status === "success") {
        const newPosts = response.payload.data;

        if (newPosts.length > 0) {
          setPosts((prevPosts) => [...prevPosts, ...newPosts]);
          setPage((prevPage) => prevPage + 1);
          setlast_Id(response.payload.lastCompanyPostId);
        }

        if (last_Id === 1) {
          setAllLoaded(true);
          startThrottle();
        }
      } else {
        setAllLoaded(true);
        startThrottle();
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      fetchingRef.current = false;
      setLoading(false);
    }
  }, [page, Loading, allLoaded]);

  const startThrottle = () => {
    if (!throttleRef.current) {
      throttleRef.current = setTimeout(() => {

        throttleRef.current = null;
      }, 5 * 60 * 1000);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !Loading && !allLoaded) {

          fetchPosts();
        }
      },
      { threshold: 1.0 }
    );

    const target = document.getElementById("loadMoreTrigger");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, [fetchPosts, Loading, allLoaded]);

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      event.target.value = null;
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file));

      if (file.type.startsWith("image")) {
        setFileType("image");
      } else if (file.type.startsWith("video")) {
        setFileType("video");
      } else if (file.type.startsWith("audio")) {
        setFileType("audio");
      }
    }
  };
  const handlePost = async () => {
    if (selectedFile || text) {
      const data = new FormData();
      data.append("file", selectedFile);
      data.append("text", text);
      data.append("userId", userId);
      data.append("company_id", company_id);
      data.append("post_access", access.post_access);
      data.append("post_per_weak", access.post_per_weak);
      data.append("post_total_limit", access.post_total_limit);
      data.append("post_unlimited_access", access.post_unlimited_access);

      const response = await dispatch(TimelineInsert(data));

      if (response?.payload?.status == "success") {

        const newPost = await dispatch(TimelineGet({ userId, company_id, page: 0, last_Id: 0 }));
        let newpostdone = newPost?.payload?.data;
        setPosts(newpostdone)

        setPreview(null);
        setText("");
        toast.success("Post Uploaded Successful");
      } else if (response.payload.status == "error") {
        setPreview(null);
        setText("");
        toast.error(response.payload.msz);
      } else {
        setPreview(null);
        setText(null);
        toast.error("ERROR");
      }
    } else {
      toast.error("Your post is empty. Please add something to share.");
    }
  };
  const handleFileSelect = (inputRef, type) => {
    if (inputRef.current) {
      setFileType(type);
      inputRef.current.click();
    }
  };

  const handleEmojiClick = (emojiData) => {
    setText((prev) => prev + emojiData.emoji);
  };

  const handleLike = async (
    company_post_id,
    post_like,
    company_like,
    liked
  ) => {
    let new_like_count = liked ? Number(post_like) - 1 : Number(post_like) + 1;
    let new_like_status = liked ? 0 : 1;


    let companyLikeArray = company_like
      ? company_like.split(",").filter(Boolean).map(Number)
      : [];


    let new_company_like
    const uid = Number(userId);

    if (new_like_status === 1) {
      // user liked
      
      if (!companyLikeArray.includes(uid)) {
        companyLikeArray.push(uid);
      }
    } else {
      // user unliked
      companyLikeArray = companyLikeArray.filter(id => id !== uid);
    }


    new_company_like = companyLikeArray.join();

    const response = await dispatch(
      TimelineLike({ company_post_id, new_like_count, new_company_like, user_id: userId })
    );

    if (response.payload.status === "success") {
      setPosts((prevPosts) =>
        prevPosts.map((post) =>
          post?.company_post_id == company_post_id
            ? {
              ...post,
              post_like: new_like_count,
              liked: new_like_status,
              company_like: new_company_like,
            }
            : post
        )
      );
    } else {
      toast.error("Failed to update like status");
    }
  };


  const setcomment = (data) => {
    setcommentPost(data);
    setShowCommentModal(true);
  };
  const handleDelete = async (post) => {

    const response = await dispatch(DeletePost({ postid: post?.company_post_id }));


    if (response?.payload?.status == "success") {
      const newPost = await dispatch(TimelineGet({ userId, company_id, page: 0, last_Id: 0 }));
      const updatedPosts = newPost?.payload?.data;
      setPosts(updatedPosts);
      toast.success("Post deleted Succesfully..");
    } else {
      toast.error("error in deleting post..");
    }

  };

  return (
    <>
      {loading && <Lodderr />}
      <CommentModal
        show={showCommentModal}
        data={commentPost}
        handleClose={() => setShowCommentModal(false)}
      />
      <motion.div
        className="tl-wrap"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: [0.22, 0.68, 0, 1.2] }}
      >
        {(access.post_access && access.post_access === "1") && (
          <div className="tl-composer">
            <textarea
              className="tl-textarea"
              placeholder="Share an update with your network..."
              rows="3"
              value={text}
              onChange={(e) => setText(e.target.value)}
            ></textarea>

            {preview && (
              <div className="tl-preview">
                <button className="tl-preview-x" onClick={() => setPreview(null)} type="button">
                  <i className="bx bx-x"></i>
                </button>
                {fileType === "image" && <img src={preview} alt="Preview" />}
                {fileType === "video" && <video src={preview} controls />}
                {fileType === "audio" && <audio src={preview} controls />}
              </div>
            )}

            {showEmojiPicker && (
              <div className="tl-emoji">
                <EmojiPicker onEmojiClick={handleEmojiClick} />
              </div>
            )}

            <div className="tl-actions">
              <div className="tl-left">
                <button className="rm-view-btn" type="button" onClick={() => handleFileSelect(photoInputRef, "image")}>
                  <i className="bx bx-image"></i> Photo
                </button>
                <button className="rm-view-btn" type="button" onClick={() => handleFileSelect(videoInputRef, "video")}>
                  <i className="bx bx-video"></i> Video
                </button>
                <button className="rm-view-btn" type="button" onClick={() => handleFileSelect(musicInputRef, "audio")}>
                  <i className="bx bx-music"></i> Audio
                </button>
              </div>

              <div className="tl-right">
                <button className="rm-view-btn" type="button" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                  <i className="bx bx-smile"></i>
                </button>
                <button className="tl-post-btn" type="button" onClick={handlePost}>
                  <i className="bx bx-send"></i> Post
                </button>
              </div>

              <input type="file" accept="image/*" ref={photoInputRef} className="d-none" onChange={handleFileChange} />
              <input type="file" accept="video/*" ref={videoInputRef} className="d-none" onChange={handleFileChange} />
              <input type="file" accept="audio/*" ref={musicInputRef} className="d-none" onChange={handleFileChange} />
            </div>
          </div>
        )}

        {posts.length > 0 ? posts.map((post, index) => (
            <div key={index} className="tl-post">
              
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-center ">
                  <img
                    src={
                      post?.member_logo
                        ? post.member_logo
                        : `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                    }
                    className="rounded-circle me-2 tl-avatar"
                    alt="User"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "/gray-avatar-icon-vector-illustration_276184-163.avif";
                    }}
                  />
                  <div>
                    <h6 className="mb-0 tl-name">{post?.member_name}</h6>
                    <p className="mb-0 tl-company">{post?.company_name}</p>
                  </div>
                </div>

                {userId == post?.member_id && company_id == post?.company_id && (
                  <button
                    className="tl-del"
                    onClick={() => {
                      setPostToDelete(post);
                      setShowDeleteModal(true);
                    }}
                    type="button"
                  >
                    <i className="bx bx-trash"></i>
                  </button>
                )}
              </div>

              
              {post?.text && !post?.text.startsWith("blob:") && (
                <p className="tl-text">{post.text}</p>
              )}

              
              {post?.text?.startsWith("blob:") && (
                <div className="ratio ratio-16x9">
                  {post?.text.includes("video") ? (
                    <video src={post?.text} controls className="w-100 h-100"></video>
                  ) : (
                    <img src={post?.text} alt="Post Preview" className="w-100 h-100" />
                  )}
                </div>
              )}

              
              {post?.file_extension && post?.file_url && (
                <div className="mt-2">
                  {post.file_extension === "image" ? (
                    <LazyLoad>
                      <img
                        src={post.file_url}
                        className="w-100"
                        style={{ maxHeight: "520px", objectFit: "cover" }}
                        alt="Post Image"
                      />
                    </LazyLoad>
                  ) : post.file_extension === "video" ? (
                    <div className="ratio ratio-16x9">
                      <video src={post.file_url} controls className="w-100 h-100 tl-media"></video>
                    </div>
                  ) : post.file_extension === "audio" ? (
                    <div className="tl-audio">
                      <audio src={post.file_url} controls />
                    </div>
                  ) : null}
                </div>
              )}

              
              <div className="tl-foot">
                <button
                  className={`tl-like ${post?.liked ? "active" : ""}`}
                  onClick={() =>
                    handleLike(
                      post?.company_post_id,
                      post?.post_like,
                      post?.company_like,
                      post?.liked
                    )
                  }
                >
                  <i className={`bx ${post?.liked ? "bxs-heart" : "bx-heart"}`}></i>
                  {post?.post_like} Like
                </button>

                <button
                  className="tl-comment"
                  onClick={() => setcomment(post)}
                >
                  <i className="bx bx-comment"></i> Comment
                </button>
              </div>
            </div>
          )) : (
          <div className="tl-empty">
            <i className="bx bx-message-square-dots"></i>
            <p>No posts yet. Share your first update above.</p>
          </div>
        )}

        <ConfirmModal
          isOpen={showDeleteModal}
          message="Are you sure you want to delete this post?"
          onCancel={() => setShowDeleteModal(false)}
          onConfirm={() => {
            handleDelete(postToDelete);
            setShowDeleteModal(false);
          }}
        />

        <div id="loadMoreTrigger"></div>
      </motion.div>
    </>
  );
};

export default AllTimeline;
